const winW = window.innerWidth
const winH = window.innerHeight

class Picture extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      isReady: true,
      srcSetJpg: '',
      srcSetWebp: '',
      srcMobile: `
        ${this.props.src}?w=${winW}&fm=jpg 1x,
        ${this.props.src}?w=${Math.round(winW * 1.5)}&fm=jpg 1.5x,
        ${this.props.src}?w=${winW * 2}&fm=jpg 2x
      `,
      src: ''
    }
  }

  componentDidMount() {


    const isPortrait = this.props.width <= this.props.height
    const width = this.refs.el.offsetWidth < winW ? this.refs.el.offsetWidth : winW
    const height = this.refs.el.offsetHeight > winH ? this.refs.el.offsetHeight : winH

    if (isPortrait && this.props.isBackground) {
      this.setState({
        src: `${this.props.src}?h=${Math.round(height * 1)}&fm=jpg`,
        srcSetJpg: `
          ${this.props.src}?h=${height > 0 ? height * 1 : winH}&fm=jpg 1x,
          ${this.props.src}?h=${Math.round(height > 0 ? height * 1 : winH)}&fm=jpg 1.5x,
          ${this.props.src}?h=${Math.round(height > 0 ? height * 2 : winH)}&fm=jpg 2x
        `
      })
    } else {
      this.setState({
        src: `${this.props.src}?w=${Math.round(width > 0 ? width * 1 : winW)}&fm=jpg`,
        srcSetJpg: `
          ${this.props.src}?w=${width > 0 ? width * 1 : winW}&fm=jpg 1x,
          ${this.props.src}?w=${Math.round(width > 0 ? width * 1 : winW)}&fm=jpg 1.5x,
          ${this.props.src}?w=${Math.round(width > 0 ? width * 2 : winW)}&fm=jpg 2x
        `
      })
    }
  }

  render() {

    const src = this.props.src;
    const proHeight = this.props.proHeight ? "pro-height" : "";
    const isReady = this.state.isReady ? "ready" : "";
    const className = this.props.className ? this.props.className : "";

    return (
      <picture className={`${className} ${proHeight} ${isReady}`} ref="el">
        <source type="image/jpg" srcSet={this.state.srcSetJpg} media="(min-width: 50em)" />
        <source type="image/jpg" srcSet={this.state.srcMobile} media="(min-width: 0em)" />
        <img src={this.state.src} ref={this.props.innerRef} />
      </picture>
    )
  }
}

export default Picture;



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Picture.js